import __vue_normalize__ from '../../../../common/temp/node_modules/.pnpm/registry.npmjs.org/vue-runtime-helpers/1.1.2/node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './TcTextArea.vue_rollup-plugin-vue=script.js';
import './TcTextArea.vue_rollup-plugin-vue=styles.0.css.js';

/* script */
var __vue_script__ = script;
/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('textarea',_vm._g(_vm._b({staticClass:"tc-text-area tc-body",attrs:{"rows":_vm.rows,"id":_vm.resolvedId,"required":_vm.isRequired,"disabled":_vm.disabled}},'textarea',_vm.$attrs,false),_vm.eventListeners)),_vm._v(" "),(_vm.hasLabel)?_c('tc-label',{staticClass:"tc-body",attrs:{"for":_vm.resolvedId,"required-field":_vm.isRequired}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.pending)?_c('tc-validation-pending'):_vm._e(),_vm._v(" "),(_vm.assistiveText)?_c('small',{staticClass:"tc-body--s assistive-text"},[_vm._v("\n    "+_vm._s(_vm.assistiveText)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.validationMessage)?_c('tc-validation-error',{class:_vm.classes},[_vm._v("\n    "+_vm._s(_vm.validationMessage)+"\n  ")]):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
